namespace $.$$ {

	$mol_style_define( $shm_hitalama_command_palette, {

		position: 'fixed',
		inset: '0',
		zIndex: $mol_layer.popup,
		pointerEvents: 'none',

		Panel: {
			position: 'absolute',
			top: $mol_gap.block,
			left: '50%',
			transform: 'translateX(-50%)',
			width: '42rem',
			maxWidth: '100%',
			maxHeight: $mol_style_unit.vh( 90 ),
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.space,
			padding: $mol_gap.space,
			border: {
				radius: $mol_gap.round,
			},
			background: {
				color: $mol_theme.back,
			},
			boxShadow: '0 0.5rem 2rem hsla(0,0%,0%,.35)',
			pointerEvents: 'auto',
		},

		Search: {
			width: '100%',
		},

		List: {
			maxHeight: '20rem',
			overflow: 'auto',
			flex: {
				direction: 'column',
			},
		},

		Command_row: {
			justify: {
				content: 'flex-start',
			},
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
			},
			'[selected]': {
				true: {
					background: {
						color: $mol_theme.hover,
					},
				},
			},
		},

	} )

}
